module.exports = __webpack_public_path__ + "6bd6b685de10ebd98db7584e37451695.ico";


//////////////////
// WEBPACK FOOTER
// ./web/images/favicon.ico
// module id = 609
// module chunks = 0